export const drawer = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (function(window, document, $) {
    const $drawer = $('.drawer'); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const bodyElement = document.querySelector('body');
    if ($drawer.length === 0 || !bodyElement) return;

    const drawerBreakpoint = window.matchMedia('(min-width: 1109px)'); // NOTE できればCSS Variablesを参照する
    const handleMediaQuery = function(mediaQuery) {
      if (mediaQuery.matches) {
        if (bodyElement.classList.contains('drawer-close') || bodyElement.classList.contains('drawer-open')) {
          $drawer.drawer('close').drawer('destroy');
          bodyElement.classList.remove('drawer-close', 'drawer-open');
        }
      } else {
        if (bodyElement.classList.contains('drawer-close') || bodyElement.classList.contains('drawer-open')) return;

        $drawer.drawer();
      }
    };
    // Register
    handleMediaQuery(drawerBreakpoint);
    drawerBreakpoint.addListener(handleMediaQuery);
  })
  (window, document, jQuery);
};